// import React from 'react'

const formatPrice = (price, currency = 'CHF') =>
	`${price.toFixed(2).replace('.', ',')} ${currency}`

export default formatPrice
